<p-select
  [options]="options"
  [(ngModel)]="selectedOption"
  [inputId]="inputElementId"
  [styleClass]="styleClass"
  [ariaFilterLabel]="ariaFilterLabel"
  [placeholder]="placeholder"
  [required]="required"
  [dropdownIcon]="dropDownIcon"
  [filter]="enableSearch"
  [filterBy]="searchFilterBy"
  [optionLabel]="searchOptionLabel"
  [resetFilterOnHide]=true
  [autoDisplayFirst]="autoDisplayFirst"
  (keydown)="handleKeydownEvent($event)"
  (onChange)="onChange($event)"
  (onHide)="handleOnHideEvent()"
  (onShow)="handleOnShowEvent()"
  (onBlur)="handleOnBlur()"
>
</p-select>
